import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Comment, CommentFilter, MovieModel, MovieViewLogFliter } from 'src/app/core/interfaces/movie.model';
import { Account, FollowItem } from 'src/app/core/interfaces/user.model';
import { AccountService } from 'src/app/core/services/account.service';
import { MoviesService } from 'src/app/core/services/movies.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit {

  account: Account;
  authorised = false;

  tituloFavoritos = "Peliculas Favoritas";
  tituloRecientes = "Peliculas Vistas Este Mes";

  perfilNombre = "Nombre Persona";
  perfilVistasTotales = 0;
  perfilVistasMes = 0;

  tieneCuponera = true;
  perfilDispoiblesCupon = 1;

  perfilPelisFavoritas: MovieModel[] = [];
  perfilPelisRecientes: MovieModel[] = [];
  perfilUltimosComentarios: Comment[] = [];

  swiperConfig: SwiperConfigInterface;
  swiperIndex = 0;

  followerAmount = 0;
  followingAmount = 0;

  followers: number[] = [];
  following: number[] = [];

  modalFollowers: any;
  modalFollowing: any;

  constructor(
    private moviesService: MoviesService,
    private router: Router,
    private accountService: AccountService,

  ) {
    this.swiperConfig = {
      slidesPerView: 2,
      spaceBetween: -10,
      navigation: false,
      breakpoints: {
        480: { slidesPerView: 3 },
        700: { slidesPerView: 4 },
        1000: { slidesPerView: 6 },
        1600: { slidesPerView: 8 }
      }
    }
  }

  ngOnInit(): void {
    this.chequearLoginYCargarDatos();
  }

  cargarDatos() {
    this.modalFollowers = $('#modalFollowers');
    this.modalFollowing = $('#modalFollowing');
    this.cargarDatosExtras();
    this.cargarPeliculasFavoritas();
    this.cargarPeliculasRecientes();
    this.cargarCommentarios();
  }

  chequearLoginYCargarDatos() { //COMPRUEBA QUE ESTES LOGEADO Y CARGA TODO.

    this.accountService.getAccount().then(
      (res: Account) => {
        if (res) {
          this.account = res;

          if (this.account == null) {
            this.router.navigateByUrl('/login');
          }
          else {
            this.authorised = true;
            this.cargarDatos(); //LLAMADA IMPORTANTE ACA SE CARGA TODO.
          }
        }
      },
      (error) => {
        this.router.navigateByUrl('/login');
      },
    );

  }

  cargarPeliculasFavoritas() {
    this.moviesService.GetFavoritesUserFilms(this.account.id).subscribe((resp: MovieModel[]) => {
      this.perfilPelisFavoritas = resp;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
    );
  }

  randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  cargarPeliculasRecientes() {

    let sub = moment();
    sub.subtract(sub.date(), "days");

    let filter: MovieViewLogFliter = {
      DateFrom: sub.format('YYYY-MM-DDTHH:mm:ss'),
      DateTo: moment().format('YYYY-MM-DDTHH:mm:ss'),
      UserId: 0
    }

    this.moviesService.getMoviesSeenByUser(filter).subscribe((res) => {
      let temp = [];
      res.forEach(log => {
        temp.push(log.movie);

        this.perfilPelisRecientes.push(log.movie);
      });
      this.perfilPelisRecientes = temp.slice(0, 6);
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );
  }

  cargarDatosExtras() {

    this.perfilNombre = this.account.firstName + " " + this.account.lastName;

    if (this.account.suscription == null) {
      this.tieneCuponera = false;
    }
    else {
      this.tieneCuponera = true;
      this.perfilDispoiblesCupon = this.account.suscription.subscriptionPlanCoupon - this.account.suscription.couponUse;
    }

    let sub = moment();
    sub.subtract(sub.date(), "days");

    let filter: MovieViewLogFliter = {
      DateFrom: sub.format('YYYY-MM-DDTHH:mm:ss'),
      DateTo: moment().format('YYYY-MM-DDTHH:mm:ss'),
      UserId: 0
    }

    //NUMERO VISTAS TOTALES
    this.moviesService.getUserTotalSeen(filter).subscribe((res) => {
      this.perfilVistasTotales = res;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
    );

    //NUMERO DE VISTAS ESTE MES
    this.moviesService.getUserMonthlySeen(filter).subscribe((res) => {
      this.perfilVistasMes = res;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
    );

    this.cargarFollows();

  }

  cargarCommentarios() { //SE VAN A MOSTRAR LOS PRIMEROS 3, SE PUEDE CAMBIAR LA CANTIDAD.
    let cantidad = 3;
    this.moviesService.getCommentsByUser(0).subscribe((res) => {
      this.perfilUltimosComentarios = res.slice(0, cantidad);
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
    );
  }

  cargarFollows() {
    //cantidad de followers
    this.accountService.getFollowerAmount(this.account.id).subscribe((res) => {
      this.followerAmount = res;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );

    //cantidad de followings
    this.accountService.getFollowingAmount(this.account.id).subscribe((res) => {
      this.followingAmount = res;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );

    this.accountService.getFollowers(this.account.id).subscribe((res) => {
      res.forEach(f => {
        this.followers.push(f.follower);
      });
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );

    this.accountService.getFollowing(this.account.id).subscribe((res) => {
      res.forEach(f => {
        this.following.push(f.followed);
      });

    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      }
    );

  }

  onOpenFollowers() {
    this.modalFollowers.modal('show');
  }

  onOpenFollowing() {
    this.modalFollowing.modal('show');
  }

  closeModalFollowers() {
    this.modalFollowers.modal('hide');
  }

  closeModalFollowing() {
    this.modalFollowing.modal('hide');
  }

}
